export default __webpack_public_path__ + "static/send-video-aaa29e043db75dba2414e09d8c88dde1.png";